import {
    AppBar,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Toolbar,
    Typography,
} from "@mui/material";
import SiteLink from "types/SiteLink";
import CloseIcon from "@mui/icons-material/Close";

export interface SiteLinkDialogProps {
    closeDialog: () => void;
    siteLink: SiteLink;
}

export function SiteLinkDialog(props: SiteLinkDialogProps) {
    return (
        <Dialog
            open={true}
            fullScreen={true}
        >
            <AppBar sx={{ position: "relative" }}>
                <Toolbar>
                    <Typography
                        sx={{ ml: 2, flex: 1 }}
                        variant="h6"
                        component="div"
                    >
                        {props.siteLink.displayName}
                    </Typography>
                    <Button
                        autoFocus
                        color="inherit"
                        onClick={props.closeDialog}
                    >
                        <CloseIcon />
                    </Button>
                </Toolbar>
            </AppBar>
            <DialogContent>
                <iframe
                    src={props.siteLink.url}
                    style={{
                        width: "100%",
                        height: "calc(100% - 10px)",
                        border: "none",
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={props.closeDialog}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}
